module.exports = "/images/mia.png?8be7cb2bb88e145eac277e9268a16ec9";